module.exports = __webpack_public_path__ + "img/ShuttleCentral-ilus1.9c924c16.png";